/** The ShellApi context lives alone so pages and hooks can read it without importing the route table. */
import { createContext, useContext } from 'react';
import type { ShellApi } from './types';

export const ShellContext = createContext<ShellApi | null>(null);

export function useShell(): ShellApi {
  const api = useContext(ShellContext);
  if (!api) throw new Error('useShell must be used inside <ShellProvider>');
  return api;
}
